import { Button, Classes } from '@blueprintjs/core'
import moment from 'moment-timezone'
import React from 'react'
import { CSVLink } from 'react-csv'
import InfiniteScroll from 'react-infinite-scroller'
import { CLIENTS, CSV_CONFIG, LEVELS, STATES, SPECIALITIES, FROM_TO_DATE_TIME, ERROR_TOAST_ICON, SHORT_TIME_FORMAT_24, DATE_FORMAT } from '../../../utils/Constants'
import LoadingSpinner from '../../loadingSpinner'
import { getProvider } from '../../services/providerApiService'
import { getTrip, getTrips } from '../../services/tripApiService'
import {
	backToTopButton, exportFileButton, flexCenter, justifyCenter,
	footerButtonsContainer, openTripsContainer, openTripsHeaderContainer, openTripsHeaderSubcontainer,
	popoverContainerDiv, refreshButtonContainer, tripsSpan
} from '../../styles'
import { AppToaster } from "../../toastComponent"
import FilterModal, { getFilters, getSpecialtyFilter, getDateTimeFilter } from '../modalComponents/filterModal'
import TripsDetailsComponent from '../tripDetails/tripsDetailsComponent'
import OpenTripsTable from './openTripsTable'
import { formatPhoneNumber, formatValue, formatNumber } from '../../../utils/helpers';


const localserviceArea = JSON.parse(localStorage.getItem('serviceAreaCheckboxs'));
const localclientOptions = JSON.parse(localStorage.getItem('clientOptionsCheckboxs'));
const locallevelOptions = JSON.parse(localStorage.getItem('levelOptionsCheckboxs'));
const localspecialtyOptions = JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs'));
const localFromToDateTime = JSON.parse(localStorage.getItem('fromToDateTimeValues'));
const CSV_HEADERS = [
	{ label: 'Due Date', key: 'dueDate' },
	{ label: 'Due Time', key: 'dueTime' },
	{ label: 'Service Level', key: 'serviceLevel' },
	{ label: 'Name', key: 'passengerNames' },
	{ label: 'Phone', key: 'pickupPhone' },
	{ label: 'PU Address', key: 'pUFormattedAddress' },
	{ label: 'DO Address', key: 'dOFormattedAddress' },
	{ label: 'NTS Trip #', key: 'sourceTripNumber' },
	{ label: 'Bolt Trip Id', key: 'boltTripId' },
	{ label: 'Driver Notes', key: 'driverNotes' },
	{ label: 'Miles', key: 'tripMiles' },
]

export default class OpenTripsContainer extends React.Component {
	constructor(props) {
		super(props);
		this.csvLink = React.createRef();
		this.state = {
			offsetCount: 0,
			tripsTop: 100,
			isOpenTrip: true,
			isLoadMoreDisabled: true,
			isCalendarOpen: false,
			trips: [],
			selectedTrip: null,
			selectedRow: null,
			isLoading: true,
			isOpenFilter:null,
			serviceAreaCheckboxs: localserviceArea ? localserviceArea : STATES,
			clientOptionsCheckboxs: localclientOptions ? localclientOptions : CLIENTS,
			levelOptionsCheckboxs: locallevelOptions ? locallevelOptions : LEVELS,
			specialtyOptionsCheckboxs: localspecialtyOptions ? localspecialtyOptions : SPECIALITIES,
			fromToDateTimeValues : localFromToDateTime ? localFromToDateTime : FROM_TO_DATE_TIME,
			sortBy: 'DueTime',
			sortOrder: 'ASC',
			openTripContainer: true,
			dueDate: moment(),
			tableRef: React.createRef(),
			csvTrips: [],
			csvOffset: 0,
			csvTop: 1000,
			allTripsSearched: false,
			csvLoading: false,
			isLoadingKeyEvents: false,
			isLoadingDetails: false,
		};
	}

	handleBackToTopClick = () => {
		this.state.tableRef.current.scrollIntoView({
			block: 'start',
			behavior: 'smooth',
		});
	}

	handleEnabledChange = async (event) => {
		const target = event.currentTarget;
		const name = target.name;
		let update = false;

		if (name === "isOpenTrip" && !this.state.isOpenTrip) {
			const value = !this.state.isOpenTrip;
			await this.setState({
				trips: [],
				isOpenTrip: value,
				isLateTrip: !value,
				isNonParTrip: !value,
				selectedTrip: null,
			})
			update = true;
		} else if (name === "isNonParTrip" && !this.state.isNonParTrip) {
			const value = !this.state.isNonParTrip;
			await this.setState({
				trips: [],
				isOpenTrip: !value,
				isLateTrip: !value,
				isNonParTrip: value,
				selectedTrip: null
			})

			update = true;
		}

		if (update) {
			this.handleFilter();
		}
	}


	handleLoadMore = async () => {
		if (this.state.trips.length === 0) {
			return;
		}

		var offsetCount = this.state.offsetCount + 1;

		await this.setState({
			isLoadMoreDisabled: true,
			isLoading: true,
		});
		await this.getTrips(offsetCount);
	}

	getTrips = async (offsetCount) => {

		if(this.state.fromToDateTimeValues.some((dateTime) => !dateTime.date || !dateTime.time )){
			AppToaster.show({ message: "From/To Date and Time are required", intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
			this.setState({
				isLoading: false,
				isOpenFilter: true
			});
      
			this.setState({isOpenFilter: null});
			return;
		}
		
		try {
			const offset = this.state.tripsTop * offsetCount;
			const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
			const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
			const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
			var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
			var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
			var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");
			var fromDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "fromDateTime");
			var toDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "toDateTime");

			let trips = this.state.trips;
			let newTrips = [];
			if (this.state.isOpenTrip) {
				const params = {
					status: 'Open', top: this.state.tripsTop, offset: offset, dueTimeAfter: fromDateTime , dueTimeBefore: toDateTime, state: stateFilter,
					SortBy: this.state.sortBy, SortOrder: this.state.sortOrder, client: clientFilter, serviceLevel: levelFilter,
					serviceMethod: 'Bolt,MDD,RideShare', isVip: isVip, WheelchairType: isOversizeWC, dialysis: isDialysis
				}

				Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);
				newTrips = await getTrips(params);
			} else if (this.state.isNonParTrip) {
				const params = {
					status: 'Confirmed', top: this.state.tripsTop, offset: offset, dueTimeAfter: fromDateTime ,dueTimeBefore: toDateTime, state: stateFilter,
					SortBy: this.state.sortBy, SortOrder: this.state.sortOrder, client: clientFilter, serviceLevel: levelFilter,
					serviceMethod: 'NonPar', isVip: isVip, WheelchairType: isOversizeWC, dialysis: isDialysis
				}

				Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);
				newTrips = await getTrips(params);
			}

			if (newTrips.length === 0) {
				AppToaster.show({ message: 'No trips found.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });

				return;
			}

			trips = trips.concat(newTrips);

			this.setState({
				offsetCount: offsetCount,
				trips: trips,
				isLoadMoreDisabled: newTrips.length < this.state.tripsTop ? true : false,
			})
		}
		catch (error) {
			console.log(error);
		}
		finally {
			this.setState({
				isLoading: false,
			})
		}
	}

	setSelectedTrip = async (e) => {
		try {
			if (e.currentTarget !== this.state.selectedRow) {
				const tripNumber = e.currentTarget.getAttribute('id');
				if (this.state.selectedRow != null) {
					const selectedRow = this.state.selectedRow;
					selectedRow.bgColor = '';

					this.setState({
						selectedRow: selectedRow,
					})
				}

				var currentTarget = e.currentTarget;
				currentTarget.bgColor = this.props.themeName === Classes.DARK ? '#00000020' : '#cccccc';

				await this.setState({
					selectedRow: currentTarget,
					isLoadingDetails: true,
					isLoadingKeyEvents: true,
				})

				const trip = await getTrip(tripNumber);

				this.setState({
					selectedTrip: trip,
					isLoadingDetails: false
				});

				if (trip.preferredProviderId) {
					await getProvider(trip.preferredProviderId).then(provider =>
						this.setState({
							selectedTrip: {
								...this.state.selectedTrip,
								preferredProvider: provider
							}
						}));
				}
			}
		}
		catch (error) {
			console.log(error);
			let message = 'Unexpected error.';

			if (error.response?.status === 404) {
				message = 'No trip found.';
			}
			AppToaster.show({ message: message, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
		}
	}

	refreshTrips = async (sortBy, sortOrder) => {
		await this.setState({
			isLoadMoreDisabled: true,
			offsetCount: 0,
			trips: [],
			selectedTrip: null,
			isLoading: true,
			sortBy: sortBy,
			sortOrder: sortOrder
		});

		this.getTrips(this.state.offsetCount);
	}

	handleFilter = async () => {
		this.setState({
			csvOffset: 0,
			csvTrips: [],
			allTripsSearched: false
		})
		this.refreshTrips(this.state.sortBy, this.state.sortOrder);
	}

	componentDidMount() {
		this.getTrips(this.state.offsetCount);

		this.props.handleHeaderPathChange('Open Trips');
	}

	handleKeySpinner() {
		this.setState({ isLoadingKeyEvents: false });
	}

	getSelectedCheckbox = () => {
		let selectedCheckbox = '';
		if (this.state.isOpenTrip) {
			selectedCheckbox = 'isOpenTrip';
		}
		else if (this.state.isNonParTrip) {
			selectedCheckbox = 'isNonParTrip';
		}

		return selectedCheckbox;
	}

	getCsvFilename = () => {
		const date = moment().format('YYYYMMDDHHmmss');

		return `Open_Trips_${date}.csv`;
	}

	exportCsv = async () => {
		this.setState({ csvLoading: true });
		while (!this.state.allTripsSearched) {
			try {
				const offset = this.state.csvTop * this.state.csvOffset;
				const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
				const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
				const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
				var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
				var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
				var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");

				let trips = this.state.csvTrips;
				let newTrips = [];

				if (this.state.isOpenTrip) {
					const dateTimeBefore = moment().add(4, 'days').utc().format();
					const params = {
						status: 'Open', top: this.state.csvTop, offset: offset, dueTimeBefore: dateTimeBefore, state: stateFilter,
						SortBy: this.state.sortBy, SortOrder: this.state.sortOrder, client: clientFilter, serviceLevel: levelFilter,
						serviceMethod: 'Bolt,MDD,RideShare', isVip: isVip, WheelchairType: isOversizeWC, dialysis: isDialysis
					}

					Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);

					newTrips = await getTrips(params);
				} else if (this.state.isNonParTrip) {
					const dateTimeBefore = moment().add(4, 'days').utc().format();
					const params = {
						status: 'Confirmed', top: this.state.csvTop, offset: offset, dueTimeBefore: dateTimeBefore, state: stateFilter,
						SortBy: this.state.sortBy, SortOrder: this.state.sortOrder, client: clientFilter, serviceLevel: levelFilter,
						serviceMethod: 'NonPar', isVip: isVip, WheelchairType: isOversizeWC, dialysis: isDialysis
					}

					Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);

					newTrips = await getTrips(params);
				}

				const formattedTrips = [];

				newTrips.forEach(function (trip) {
					formattedTrips.push({
						dueDate: moment.tz(trip.dueDateTime, trip.pickupTimeZone).format(`${DATE_FORMAT}`),
						dueTime: moment.tz(trip.dueDateTime, trip.pickupTimeZone).format(`${SHORT_TIME_FORMAT_24}`),
						serviceLevel: formatValue(trip.serviceLevel),
						passengerNames: `${formatValue(trip.passengerFirstName)} ${formatValue(trip.passengerLastName)}`,
						pickupPhone: formatPhoneNumber(trip.pickupPhone),
						pUFormattedAddress: `${formatValue(trip.pickupAddressLine1)}, ${formatValue(trip.pickupAddressLine2)}, ${formatValue(trip.pickupCity)}, ${formatValue(trip.pickupState)}`.replace(' ,',''),
						dOFormattedAddress: `${formatValue(trip.dropoffAddressLine1)}, ${formatValue(trip.dropoffAddressLine2)}, ${formatValue(trip.dropoffCity)}, ${formatValue(trip.dropoffState)}`.replace(' ,',''),
						sourceTripNumber: formatValue(trip.sourceTripNumber),
						boltTripId: formatValue(trip.boltTripId),
						driverNotes: formatValue(trip.driverNotes),
						tripMiles: formatNumber(trip.tripMiles, 1)
					})
				})

				trips = trips.concat(formattedTrips);

				this.setState({
					csvOffset: this.state.csvOffset + 1,
					csvTrips: trips,
					allTripsSearched: formattedTrips.length < this.state.csvTop || trips.length < this.state.csvTop || trips.length >= 5000 ? true : false,
				})
			}
			catch (error) {
				console.log(error);
				AppToaster.show({ message: 'There was an error while exporting, please try again.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
				break;
			}
		}
		this.setState({ csvLoading: false });
		this.csvLink.current.link.click()
	}


	render() {
		var tripsCount = this.state.trips.length;

		return (
			<div style={openTripsContainer}>
				{this.state.isLoading ? <LoadingSpinner /> : <></>}
				<div style={openTripsHeaderContainer}>
					<div style={openTripsHeaderSubcontainer(this.props.themeName === Classes.DARK)}>
						<div style={flexCenter}>
							<span style={tripsSpan}>Trips: {tripsCount}</span>
							<div style={popoverContainerDiv}>
								<FilterModal fatherComponent={this} />
								{this.state.trips.length !== 0 ?
									<div style={{ paddingLeft: '15px' }}>
										<Button onClick={this.exportCsv} style={exportFileButton} loading={this.state.csvLoading} intent={'primary'} icon="export" />
										<CSVLink
											filename={this.getCsvFilename()}
											data={this.state.csvTrips}
											headers={CSV_HEADERS}
											ref={this.csvLink}
											enclosingCharacter={CSV_CONFIG.enclosingCharacter}
											separator={CSV_CONFIG.separator} >
										</CSVLink>
									</div> : null
								}
							</div>
						</div>
						<div style={refreshButtonContainer}>
							<Button icon="refresh" text="Refresh" onClick={() => this.refreshTrips(this.state.sortBy, this.state.sortOrder)} />
						</div>
					</div>

					<div className="container" ref={(ref) => this.scrollParentRef = ref}>
						<InfiniteScroll
							loadMore={this.handleLoadMore}
							hasMore={!this.state.isLoadMoreDisabled}
							threshold={100}
							useWindow={true}
							getScrollParent={() => this.scrollParentRef}
						>
							<div className="mt-5 mx-auto" ref={this.state.tableRef}>
								<OpenTripsTable
									trips={this.state.trips}
									themeName={this.props.themeName}
									setSelectedTrip={this.setSelectedTrip}
									selectedTrip={this.state.selectedTrip}
									selectedCheckbox={this.getSelectedCheckbox()}
									refreshTrips={this.refreshTrips}
									customFields={this.state.trips?.customFields}
								/>
							</div>

						</InfiniteScroll>
					</div>
					<footer style={footerButtonsContainer}>
						<div style={justifyCenter}>
							<Button style={backToTopButton} icon="arrow-up" type="button" onClick={this.handleBackToTopClick} text="Back to top" intent={'primary'} />
						</div>
					</footer>
				</div>
				{
					<TripsDetailsComponent
						openTripContainer={this.state.openTripContainer}
						selectedTrip={this.state.selectedTrip}
						handleKeySpinner={this.handleKeySpinner.bind(this)}
						isLoadingKeyEvents={this.state.isLoadingKeyEvents}
						isLoadingDetails={this.state.isLoadingDetails}
					/>
				}
			</div >
		)
	}
}
